import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Grid from '@cloudscape-design/components/grid';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { signIn } from 'aws-amplify/auth';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import MetaTags from '../lib/MetaTags';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const from = useMemo(() => {
    return location.state?.from?.pathname || '/userinformations';
  }, [location]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await signIn({
        username,
        password,
      });
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.message || 'Authentication failed');
    }
  };

  return (
    <>
      <MetaTags
        title="Theo's Bistro"
        author="Theo's Bistro"
        keywords={[]}
        description="Admin page für Theo's Bistro"
      />
      <Grid
        gridDefinition={[{ colspan: 12 }, { colspan: 4, offset: { xxs: 4 } }]}
      >
        <div />
        <form onSubmit={handleSubmit}>
          <Form
            errorText={error}
            actions={
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="primary">Submit</Button>
              </SpaceBetween>
            }
          >
            <Container header={<Header variant="h2">Login</Header>}>
              <SpaceBetween direction="vertical" size="l">
                <FormField label="Username">
                  <Input
                    name="username"
                    value={username}
                    onChange={(event) => setUsername(event.detail.value)}
                  />
                </FormField>
                <FormField label="Password">
                  <Input
                    name="password"
                    value={password}
                    onChange={(event) => setPassword(event.detail.value)}
                    type="password"
                  />
                </FormField>
              </SpaceBetween>
            </Container>
          </Form>
        </form>
      </Grid>
    </>
  );
};

export default Login;
